<template>
  <div v-if="persons.length > 0" class="row">
    <div class="col-sm-12">
      <div class="card flex-column">
        <form>
          <div class="card-header">
            <h4 class="card-title">Résultats de la recherche</h4>
          </div>
          <div class="card-body">
            <div
              v-for="person in persons"
              :key="person.id"
              class="search-result"
            >
              <router-link
                :to="{ name: 'PersonDetails', params: { id: person.id } }"
              >
                {{ person.firstName }}
                <b>{{ person.lastName }}</b>
              </router-link>
            </div>
          </div>
          <div class="card-footer text-center" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from 'src/event-bus';

export default {
  name: 'OverviewSearchResultsList',
  components: {},
  props: {
    fetchData: { type: Function, default: () => {} },
  },
  data() {
    return {
      persons: [],
      searchText: '',
    };
  },
  computed: {},
  watch: {},
  created() {
    EventBus.$off('search');
    EventBus.$on('search', this.search);
  },
  beforeDestroy() {
    EventBus.$off('search', this.search);
  },
  mounted() {
    // On mounted
  },
  methods: {
    fetch() {
      this.fetchData(this.searchText)
        .then(response => {
          this.persons = response.searchResults;
        })
        .catch(error => {
          console.log(error);
        });
    },
    search(searchText) {
      this.searchText = searchText;
      this.fetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-result {
  padding: 0.5em;
}
</style>
